export default "__VITE_ASSET__c2e4b79e__"